import type { ApiPromocodeUsage, SendFormDataResult, UaeWording } from '@/shared/types/api.types'
import { CommonService } from './CommonService'
import sendFormDataResponse from '@/shared/tests/mocks/responses/sendformdata.json'
import validatePromocodeResponse from '@/shared/tests/mocks/responses/validatepromocode.json'
import getUaeWordingsResponse from '@/shared/tests/mocks/responses/getuaewordings.json'

export class CommonServiceMock extends CommonService {
  async sendFormData(): Promise<SendFormDataResult> {
    return Promise.resolve(sendFormDataResponse)
  }

  async validatePromocode(): Promise<ApiPromocodeUsage[]> {
    return Promise.resolve(validatePromocodeResponse.codeUsage as ApiPromocodeUsage[])
  }

  async getQatarWordings(): Promise<UaeWording[]> {
    return Promise.resolve(getUaeWordingsResponse.Wordings)
  }
}
